import React, { Component } from 'react'
import _ from 'lodash'
import getLabel from '../../utilities/label.js'
import TitleBar from '../TitleBar'
import UserRow from '../Users/UserRow'
import './leaderboard.css'

export default class Leaderboard extends Component {
  constructor(props) {
    const refreshButton = '<i class=\'fa fa-refresh\'></i>'
    const backButton = '<i class=\'fa fa-arrow-left\'></i> ' + getLabel('back_button')
    super(props)
    this.state = {
      leaderboard: true,
      refreshButton: refreshButton,
      backButton: backButton
    }
    this.props.setActiveTab('homepage')
    this.refresh = this.refresh.bind(this)
  }

  getUser(id) {
    return _.find(this.props.users.event_users, {user_id: parseInt(id, 10)})
  }

  getLeaderboards() {
    var eventLeaderboards = []
    var rank = 1
    var _this = this
    const colors = ['gold', 'silver', '#cc6633']
    _.each(this.props.leaderboard.event_leaderboard.event_user_leaderboards, function(event_leaderboard, i){
      var user = _this.getUser(event_leaderboard.user_id)
      if(user) {
        var addClass = user.user_id === window.currentUser.user_id ? 'lb-highlight' : ''
        eventLeaderboards.push(
          <div key={event_leaderboard.user_id} className='leaderboard-user'>
            <UserRow user={user} skipLink={true} skipGB={true} noHover={true} addClass={addClass} />
            <div className="leaderboard-rank">
              { (i < 3) && <div className="hasTrophy"><i style={{color: colors[i]}} className="fa fa-trophy"></i></div>}
              <div>
                {event_leaderboard.formatted_points || rank}
              </div>
            </div>
            <hr />
          </div>
        )
        rank += 1
      }
    })
    eventLeaderboards = eventLeaderboards < 1 ? <div className='noResults'>{getLabel('no_results_found')}</div> : eventLeaderboards
    return eventLeaderboards
  }

  getRules() {
    var leaderboard_rules = []
    // var _this = this
    leaderboard_rules.push(
      <div key="rule" className="row rules-list-header">
        <div className="col-10">{getLabel('points_awarded')}</div>
        <div className="col-2">{getLabel('points')}</div>
      </div>
    )
    _.each(this.props.leaderboard.event_leaderboard.leaderboard_rules, function(leaderboard_rule, i){
      leaderboard_rules.push(
        <div key={i}>
          <div className="row rules-list">
            <div className="col-10">{leaderboard_rule.app_label}</div>
            <div className="col-2">{leaderboard_rule.points_allocated}</div>
          </div>
          <hr />
        </div>
      )
    })
    return leaderboard_rules
  }

  refresh() {
    const refreshButton = '<i class=\'fa fa-refresh fa-spin\'></i>'
    this.setState({
      refreshButton: refreshButton
    })
    this.props.updateResource({
      key: 'leaderboard',
      update: true,
      callback: () => {
        this.setState({
          refreshButton: '<i class=\'fa fa-refresh\'></i>'
        })
      }
    })
  }

  toggleRules() {
    var leaderboard = !this.state.leaderboard
    this.setState({leaderboard: leaderboard})
    // this.state.leaderboard = !this.state.leaderboard;
  }
  render() {
    return this.state.leaderboard ? (
      <div className='leaderboard-page-board'>
        { window.trackPage('LeaderboardResultsScreen') }
        <TitleBar
          title={ getLabel('leaderboard') }
          leftButtonLabel={ this.state.backButton }
          leftButtonAction={ () => window.history.back() }
          rightButtonLabel={ this.state.refreshButton }
          rightButtonAction={ this.refresh } />
        <div className="btn-group btn-group-toggle" data-toggle="buttons">
          <label className="btn btn-secondary">
            <input type="radio" name="options" id="option2" autoComplete="off" /> {getLabel('leaderboard_results')}
          </label>
          <label className="btn btn-light" onClick={this.toggleRules.bind(this)}>
            <input type="radio" name="options" id="option3" autoComplete="off" /> {getLabel('leaderboard_rules')}
          </label>
        </div>
        {this.getLeaderboards()}
      </div>
    ) : (
      <div className='leaderboard-page-rules'>
        { window.trackPage('LeaderboardRulesScreen') }
        <TitleBar
          title={ getLabel('leaderboard_rules') }
          leftButtonLabel={ this.state.backButton }
          leftButtonAction={ () => window.history.back() }
          rightButtonLabel={ this.state.refreshButton }
          rightButtonAction={ this.refresh } />
        <div className="btn-group btn-group-toggle" data-toggle="buttons">
          <label className="btn btn-light" onClick={this.toggleRules.bind(this)}>
            <input type="radio" name="options" id="option2" autoComplete="off" /> {getLabel('leaderboard_results')}
          </label>
          <label className="btn btn-secondary">
            <input type="radio" name="options" id="option3" autoComplete="off" /> {getLabel('leaderboard_rules')}
          </label>
        </div>
        {this.getRules()}
        <p className="dim">{getLabel('lb_actions')}</p>
      </div>
    )
  }
}
